export default "__VITE_PUBLIC_ASSET__5902176b__"